// Store
import Vue from 'vue';
import EventBus from '../../EventBus';
// State
// ....
const state = {
  data: {
    apellido: '',
    nombre: '',
    fechaNacimiento: '',
    sexo: '',
    documento: '',
    telefono: '',
    email: '',
    provincia: {},
    localidad: {},
    domicilio: '',
    conyugue: '',
    sectorPostula: '',
    otroSectorPostula: '',
    trabajoReferencia: '',
    conocimientosBasicos: '',
    nivelEstudio: '',
    tituloHabilitante: '',
    foto: '',
    otra_localidad: '',
    reenviarme: false
  },
  ocupado: false
}

// Getters
// ...
const getters = {
  getData: (state) => state.data,
  getOcupado: (state) => state.ocupado,
  getApellido: (state) => state.data.apellido,
  getNombre: (state) => state.data.nombre,
  getFechaNacimiento: (state) => state.data.fechaNacimiento,
  getSexo: (state) => state.data.sexo,
  getDocumento: (state) => state.data.documento,
  getTelefono: (state) => state.data.telefono,
  getEmail: (state) => state.data.email,
  getProvincia: (state) => state.data.provincia,
  getLocalidad: (state) => state.data.localidad,
  getDomicilio: (state) => state.data.domicilio,
  getConyugue: (state) => state.data.conyugue,
  getSectorPostula: (state) => state.data.sectorPostula,
  getOtroSectorPostula: (state) => state.data.otroSectorPostula,
  getTrabajoReferencia: (state) => state.data.trabajoReferencia,
  getConocimientosBasicos: (state) => state.data.conocimientosBasicos,
  getNivelEstudio: (state) => state.data.nivelEstudio,
  getTituloHabilitante: (state) => state.data.tituloHabilitante,
  getFoto: (state) => state.data.foto,
  getReenviarme: (state) => state.data.reenviarme,
  getOtraLocalidad: (state) => state.data.otra_localidad
}

// Mutations
// ...
const mutations = {
  setOcupado: (state, payload) => state.ocupado = payload,
  setApellido: (state, payload) => state.data.apellido = payload,
  setNombre: (state, payload) => state.data.nombre = payload,
  setFechaNacimiento: (state, payload) => state.data.fechaNacimiento = payload,
  setSexo: (state, payload) => state.data.sexo = payload,
  setDocumento: (state, payload) => state.data.documento = payload,
  setTelefono: (state, payload) => state.data.telefono = payload,
  setEmail: (state, payload) => state.data.email = payload,
  setProvincia: (state, payload) => state.data.provincia = payload,
  setLocalidad: (state, payload) => state.data.localidad = payload,
  setDomicilio: (state, payload) => state.data.domicilio = payload,
  setConyugue: (state, payload) => state.data.conyugue = payload,
  setSectorPostula: (state, payload) => state.data.sectorPostula = payload,
  setOtroSectorPostula: (state, payload) => state.data.otroSectorPostula = payload,
  setTrabajoReferencia: (state, payload) => state.data.trabajoReferencia = payload,
  setConocimientosBasicos: (state, payload) => state.data.conocimientosBasicos = payload,
  setNivelEstudio: (state, payload) => state.data.nivelEstudio = payload,
  setTituloHabilitante: (state, payload) => state.data.tituloHabilitante = payload,
  setFoto: (state, payload) => state.data.foto = payload,
  setReenviarme: (state, payload) => state.data.reenviarme = payload,
  setOtraLocalidad: (state, payload) => state.data.otra_localidad = payload
}


// Actions
// ...
const actions = {
  post(state) {
    if(state.getters.getOcupado) {
      return;
    }
    this.commit('postulante/setOcupado', true);
    EventBus.$emit('ocupado', true);
    Vue.http.options.emulateJSON = true;
    let localidad = 0;
    let localidadNombre = '';
    let provincia = 0;
    let sectorPostulaNombre = '';
    if(state.getters.getLocalidad) {
      localidad = state.getters.getLocalidad.id;
      localidadNombre = state.getters.getLocalidad.nombre;
    }
    if(state.getters.getProvincia) {
      provincia = state.getters.getProvincia.id;
    }
    let data = new FormData();
    data.append('apellido', state.getters.getApellido);
    data.append('nombre', state.getters.getNombre);
    data.append('nacimiento', state.getters.getFechaNacimiento);
    data.append('sexo', state.getters.getSexo);
    data.append('documento', state.getters.getDocumento);
    data.append('telefono', state.getters.getTelefono);
    data.append('email', state.getters.getEmail);
    data.append('provincia', provincia);
    data.append('localidad', localidad);
    data.append('localidadNombre', localidadNombre);
    data.append('domicilio', state.getters.getDomicilio);
    data.append('conyugue', state.getters.getConyugue);
    if (state.getters.getSectorPostula.pm == 1) {
      data.append('sectorPostula', 2);
      data.append('rol', state.getters.getSectorPostula.id);
    } else data.append('sectorPostula', state.getters.getSectorPostula.id);
    data.append('sectorPostulaNombre', state.getters.getSectorPostula.nombre);
    data.append('otroSectorPostula', state.getters.getOtroSectorPostula);
    data.append('trabajoReferencia', state.getters.getTrabajoReferencia);
    data.append('conocimientosBasicos', state.getters.getConocimientosBasicos);
    data.append('nivelEstudio', state.getters.getNivelEstudio.id);
    data.append('nivelEstudioNombre', state.getters.getNivelEstudio.nombre);
    data.append('tituloHabilitante', state.getters.getTituloHabilitante);
    if (state.getters.getFoto) {
      data.append('foto', state.getters.getFoto, state.getters.getFoto.name);
    }
    data.append('reenviarme', state.getters.getReenviarme);
    data.append('otra_localidad', state.getters.getOtraLocalidad);

    /*let url = `http://${RRHH_APACHE_HOST}/appclinica4/public/postulante-post`;
    Vue.http.post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(response => response.json())
    .then(json => {
      this.commit('postulante/setOcupado', false);
      EventBus.$emit('ocupado', false);
    }, (reason) => {
      this.commit('postulante/setOcupado', false);
      EventBus.$emit('ocupado', false);
    });*/
    Vue.http.post(`http://${RRHH_HOST}/postulante`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(response => response.json())
    .then(json => {
      this.commit('postulante/setOcupado', false);
      EventBus.$emit('ocupado', false);
      EventBus.$emit('FINALIZADO', true);
    }, (reason) => {
      this.commit('postulante/setOcupado', false);
      EventBus.$emit('ocupado', false);
      EventBus.$emit('FINALIZADO', true);
      if(reason.body && reason.body.trim()!="") {
        EventBus.$emit('MOSTRAR_MENSAJE', reason.body);
      }
    });
  },
  clearData(state) {
    this.commit('postulante/setApellido', '');
    this.commit('postulante/setNombre', '');
    this.commit('postulante/setFechaNacimiento', '');
    this.commit('postulante/setSexo', '');
    this.commit('postulante/setDocumento', '');
    this.commit('postulante/setTelefono', '');
    this.commit('postulante/setEmail', '');
    this.commit('postulante/setProvincia', '');
    this.commit('postulante/setLocalidad', '');
    this.commit('postulante/setDomicilio', '');
    this.commit('postulante/setConyugue', '');
    this.commit('postulante/setSectorPostula', '');
    this.commit('postulante/setOtroSectorPostula', '');
    this.commit('postulante/setTrabajoReferencia', '');
    this.commit('postulante/setConocimientosBasicos', '');
    this.commit('postulante/setNivelEstudio', '');
    this.commit('postulante/setTituloHabilitante', '');
    this.commit('postulante/setFoto', '');
    this.commit('postulante/setOtraLocalidad', '');
    return true;
  }
}



// Export store
// ...
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modulos/Postulante.js